import { PropsWithChildren, createContext, useContext } from 'react'
import { CouponContextProps } from '../../pages/Coupon/types'
import useCouponStore from './useCouponStore'

const CouponContext = createContext<CouponContextProps | null>(null)

const CouponProvider = ({ children }: PropsWithChildren) => {
  const couponStore = useCouponStore()
  return (
    <CouponContext.Provider value={couponStore}>
      {children}
    </CouponContext.Provider>
  )
}

function useCouponContext() {
  const context = useContext(CouponContext)

  if (!context) {
    throw new Error('useCouponContext must be used within a CouponProvider')
  }

  return context
}

export { CouponProvider, useCouponContext }
